import { render } from "./website-web.vue?vue&type=template&id=33526d35&scoped=true"
import script from "./website-web.vue?vue&type=script&lang=js"
export * from "./website-web.vue?vue&type=script&lang=js"

import "./website-web.vue?vue&type=style&index=0&id=33526d35&lang=scss&scoped=true"

import exportComponent from "/usr/local/apps/meng/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33526d35"]])

export default __exports__